var map = {
	"./firstScreen/female.png": 3382,
	"./firstScreen/logo.png": 7325,
	"./firstScreen/male.png": 8207,
	"./firstScreen/non.png": 3014,
	"./firstScreen/security.png": 1715,
	"./loginPage/apple.png": 4918,
	"./loginPage/facebook.png": 7626,
	"./loginPage/google.png": 5730,
	"./loginPage/lock.png": 2683,
	"./loginPage/tiktok.png": 8834,
	"./logo.png": 1053,
	"./mark.png": 5910,
	"./paywall/arrows_right.png": 3784,
	"./paywall/mark.png": 4672,
	"./preloadPage/preload_1.png": 7610,
	"./preloadPage/preload_2.png": 1289,
	"./preloadPage/preload_3.png": 4390,
	"./preloadPage/preload_4.png": 6500,
	"./preloadPage/preload_5.png": 3044,
	"./preloadPage/spinner.png": 371,
	"./progress_arrowLeft.png": 299,
	"./questionIcons/quest_icon_apple.png": 7653,
	"./questionIcons/quest_icon_breakfast.png": 8651,
	"./questionIcons/quest_icon_broccoli.png": 5383,
	"./questionIcons/quest_icon_cheese.png": 6956,
	"./questionIcons/quest_icon_choco.png": 9846,
	"./questionIcons/quest_icon_concentration.png": 1194,
	"./questionIcons/quest_icon_darts.png": 1925,
	"./questionIcons/quest_icon_dinner.png": 7700,
	"./questionIcons/quest_icon_dontevent.png": 3254,
	"./questionIcons/quest_icon_female.png": 6030,
	"./questionIcons/quest_icon_fish.png": 1570,
	"./questionIcons/quest_icon_glass.png": 4536,
	"./questionIcons/quest_icon_heart_dmb.png": 7909,
	"./questionIcons/quest_icon_highactive.png": 3064,
	"./questionIcons/quest_icon_immunity.png": 7107,
	"./questionIcons/quest_icon_lightning.png": 2709,
	"./questionIcons/quest_icon_lowactive.png": 9525,
	"./questionIcons/quest_icon_lunch.png": 8211,
	"./questionIcons/quest_icon_male.png": 9298,
	"./questionIcons/quest_icon_minrest.png": 1981,
	"./questionIcons/quest_icon_moon.png": 8533,
	"./questionIcons/quest_icon_moon_filled.png": 321,
	"./questionIcons/quest_icon_noactive.png": 2585,
	"./questionIcons/quest_icon_nodiet.png": 7092,
	"./questionIcons/quest_icon_num1.png": 1357,
	"./questionIcons/quest_icon_num2.png": 4635,
	"./questionIcons/quest_icon_num3.png": 1802,
	"./questionIcons/quest_icon_num4.png": 7705,
	"./questionIcons/quest_icon_other.png": 5112,
	"./questionIcons/quest_icon_purify.png": 4188,
	"./questionIcons/quest_icon_reducestress.png": 5033,
	"./questionIcons/quest_icon_regularactive.png": 2973,
	"./questionIcons/quest_icon_salt.png": 2296,
	"./questionIcons/quest_icon_skinlook.png": 283,
	"./questionIcons/quest_icon_sleepbetter.png": 1532,
	"./questionIcons/quest_icon_sleephero.png": 6010,
	"./questionIcons/quest_icon_sleeplong.png": 1060,
	"./questionIcons/quest_icon_somerest.png": 6736,
	"./questionIcons/quest_icon_sports.png": 7496,
	"./questionIcons/quest_icon_summer.png": 2989,
	"./questionIcons/quest_icon_sun.png": 5302,
	"./questionIcons/quest_icon_vacation.png": 7127,
	"./questionIcons/quest_icon_vit_abde.png": 2809,
	"./questionIcons/quest_icon_vit_antibio.png": 6821,
	"./questionIcons/quest_icon_vit_chemistry.png": 170,
	"./questionIcons/quest_icon_vit_dont.png": 8294,
	"./questionIcons/quest_icon_vit_other.png": 6452,
	"./questionIcons/quest_icon_wedding.png": 6841,
	"./questionImages/quest_img_chart.png": 941,
	"./questionImages/quest_img_intermitted.png": 5735,
	"./questionImages/quest_img_perfect.png": 5563,
	"./questionImages/quest_img_perfect_male.png": 1489,
	"./resultPage/additional-goal-darts.png": 3761,
	"./resultPage/additional-goal-sleep.png": 7928,
	"./resultPage/additional-goal-stress.png": 115,
	"./resultPage/arrows_right.png": 5746,
	"./resultPage/chart_down.png": 3187,
	"./resultPage/chart_middle.png": 5010,
	"./resultPage/chart_up.png": 8389,
	"./resultPage/darts.png": 8965,
	"./resultPage/mark.png": 6499,
	"./resultPage/no-diet.png": 1611,
	"./resultPage/reach_darts.png": 1628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9513;